import * as React from 'react';
import { connect } from 'react-redux';
import { Grid, Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import { StyledComponentProps } from '@material-ui/core/styles';
import { IMediaQueryProps, WithMediaQuery } from '../../../../layout/withMediaQuery';
import { IApplicationState } from '../../../../store/ApplicationState';
import { IState as ISubscriptionState } from '../../../../common/store/subscriptions/state';
import { IActions as ISubscriptionsActions, actionCreator as subscriptionsActions } from '../../../../common/store/subscriptions/actions/creators';
import { IActions as IMedicalExaminationActions, actionCreator as medicalExaminationActions } from '../../../../common/store/medicalExaminations/actions/creators';
import SaveButton from '../../../../ui-components/Button/SaveButton';
import CancelButton from '../../../../ui-components/Button/CancelButton';
import DatePicker from '../../../../ui-components/DatePicker/DatePicker';
import { Select, SelectItem } from '../../../../ui-components/select/Select';
import { SUBSCRIPTIONTYPES, subscription, days } from '../../../../model/subscription';
import { invokeApi } from '../../../../common/networking/invoker';
import { SearchBoxApi } from '../../../../ui-components/SearchBoxApi/SearchBoxApi';
import { contactInsurance, contactMedicalExamination, contactSubscription, emptyContactInsurance, emptyContactMedicalExamination, emptyContactSubscription } from '../../../../model/contactsubscription';
import TextField from '../../../../ui-components/TextField/TextField';
import moment from 'moment';
import { DayRow } from '../../../subscriptions/Detail/DayRow';
import MedicalExaminationDocument from './MedicalExaminationDocument';
import { medicalExamination } from '../../../../model/medicalexamination';
import { useRef, useState } from 'react';

interface IProps extends IMediaQueryProps, ISubscriptionsActions, ISubscriptionState, IMedicalExaminationActions, IInnerProps {
}

interface IInnerProps extends StyledComponentProps {
    onCancel: () => any;
    onSaveSubscription: (contactItem: contactSubscription) => any;
    onSaveInsurance: (contactItem: contactInsurance) => any;
    onSaveMedicalExamination: (contactItem: contactMedicalExamination) => any;
    open: boolean;
    dialogType: string; // subscription | medical | insurance
    userId: string;
}
// interface IInnerState {
//     // reservationList: INormalizedObjects<reservation[]>;
// }

export const AddContactSubscriptionDialog = (props: IProps) => {

    const [medicalExaminationDocument, setMedicalExaminationDocument] = useState<medicalExamination>(null);

    // const [subscription, setSubscription] = React.useState<subscription>(undefined);
    const [notes, setNotes] = useState<string>();
    const [accessesExtra, setAccessesExtra] = useState<number>();
    const [daysExtra, setDaysExtra] = useState<number>();
    const [validFrom, setValidFrom] = useState<Date>();
    const [expireTo, setExpireTo] = useState<Date>();
    const [subscriptionType, setSubscriptionType] = useState<SelectItem>();
    const ClearItemsRef = useRef(() => { });

    // const previousValues = React.useRef({ validFrom, expireTo });
    // React.useEffect(() => {
    //     console.log("change date", validFrom, expireTo);
    //     if (previousValues.current.validFrom !== validFrom) {
    //         console.log("change VALID FROM")
    //         previousValues.current = { validFrom, expireTo };
    //     }
    //     //     // CHANGE FIRST
    //     //     changeExpireDate(props.selectedSubscription);
    //     //     previousValues.current = { validFrom, expireTo };
    //     // }
    //     if (previousValues.current.expireTo !== expireTo) {
    //         console.log("change EXPIRE TO");
    //         //     console.log("both changed")
    //         //     changeValidFromDate(props.selectedSubscription);
    //         previousValues.current = { validFrom, expireTo };
    //     }
    // }, [validFrom, expireTo])

    React.useEffect(() => {
        // console.info("## props.selectedSubscription", props.selectedSubscription);
        if (props.selectedSubscription) {
            const newValidFrom: Date = validFrom;
            changeExpireDate(newValidFrom, props.selectedSubscription);
        }
        // changeSubscriptionValue(props.selectedSubscription)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.selectedSubscription])

    React.useEffect(() => {
        // console.info("-------------------------------x-x-x-x-x-x-x---------------------3-", props.open);
        if (props.open === true) {
            ClearItemsRef.current();
            setNotes('');
            setAccessesExtra(0);
            setDaysExtra(0);
            setValidFrom(new Date());
            setExpireTo(moment(new Date()).add(12, 'M').toDate());
            setSubscriptionType({ name: 'Abbonamento', value: 'MENSILE' });
        }
    }, [props.open])

    React.useEffect(() => {
        // console.log("## daysExtra", daysExtra)
        let mesi = 12;
        if (isSubscription && props.selectedSubscription?.subscriptionType === SUBSCRIPTIONTYPES.MENSILE.code) {
            mesi = props.selectedSubscription.monthToBuy;
        }

        // console.log("MESI", mesi, "GIORNI", daysExtra);
        let fine = moment(validFrom).add(mesi, 'M').add(daysExtra, 'd').toDate();
        // console.log(validFrom);
        // console.log(fine);
        setExpireTo(fine);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [daysExtra])

    const Cancel = () => {
        props.onCancel();
        props.resetNewMedicalExamination();
    }

    const Save = () => {
        // console.info("-------------------------------x-x-x-x-x-x-x----------------------");
        // console.info(subscription);
        // console.info(validFrom);
        // console.info(expireTo);
        // console.info(subscriptionType);
        // console.info(notes);

        // VALIDATE DATE -> validFrom
        if (Object.prototype.toString.call(validFrom) === "[object Date]") {
            // it is a date
            if (isNaN(validFrom.getTime())) {  // d.valueOf() could also work
                // date is not valid
                return;
            } else {
                // date is valid
            }
        } else {
            // not a date
            return;
        }

        console.info("dialogType:", props.dialogType);
        switch (props.dialogType) {
            case "insurance":
                var m = emptyContactInsurance();
                m.validFrom = validFrom;
                m.expiresOn = expireTo;
                m.notes = notes;
                props.onSaveInsurance(m);
                break;
            case "medical":
                var i = emptyContactMedicalExamination();
                i.validFrom = validFrom;
                i.expiresOn = expireTo;
                i.notes = notes;
                console.info("## SAVE MEDICAL EXAMINATION DOCUMENT :", medicalExaminationDocument);
                if (medicalExaminationDocument) {
                    i.medicalExaminationDocumentId = medicalExaminationDocument._id;
                    i.firebaseUri = medicalExaminationDocument.firebaseUri;
                }
                props.onSaveMedicalExamination(i);
                props.resetNewMedicalExamination();
                break;
            case "subscription":
                var c = emptyContactSubscription();
                c.validFrom = validFrom;

                // DOPO AVERLA MODIFICATA PER LA VISUALIZZAZIONE
                // REIMPOSTO LA EXPIRE DATE IN MODO CORRETTO
                c.expiresOn = moment(validFrom).add(props.selectedSubscription.monthToBuy, 'M').toDate();
                if (props.selectedSubscription?.subscriptionType === SUBSCRIPTIONTYPES.ACCESSI.code) {
                    // SE ACCESSI REIMPOSTO 12 MESI
                    c.expiresOn = moment(validFrom).add(12, 'M').toDate();
                }

                c.notes = notes;
                c.accessesExtra = accessesExtra;
                c.daysExtra = daysExtra;
                c.subscription = props.selectedSubscription;
                props.onSaveSubscription(c);
                break;
        }
        // console.log(selectedDays);
        // console.log("-------------------------------x-x-x-x-x-x-x---------------------ok-");
    }

    // const clearSubItems = () => {
    //     ClearItemsRef.current();
    // }

    const changeSubscriptionTypeValue = (item: SelectItem) => {
        // console.log("## changeSubscriptionTypeValue -------------------------------x-x-x-x-x-x-x---------------------1-", item);
        if (item)
            setSubscriptionType(item);

        ClearItemsRef.current();
        // setSubscription(null); 
        // clearSubItems();

        setNotes('');
        setAccessesExtra(0);
        setDaysExtra(0);
        setValidFrom(new Date());
        setExpireTo(moment(new Date()).add(12, 'M').toDate());

    }

    // const changeSubscriptionValue = (item: subscription) => {
    //     // console.info("-------------------changeSubscriptionValue----");
    //     // console.info(item);
    //     changeExpireDate(new Date(), item);
    // }

    const changeExpireDate = (newValidFrom: Date, item: subscription) => {
        // console.log("## changeExpireDate", newValidFrom, item, isSubscription)
        let mesi = 12;
        if (isSubscription && item) {
            if (item.subscriptionType === "MENSILE") {
                mesi = item.monthToBuy;
            }
        }
        // debugger;
        let fine = moment(newValidFrom).add(mesi, 'M').add(daysExtra, 'd').toDate();
        setExpireTo(fine);
        setValidFrom(newValidFrom);
    }

    const changeValidFromDate = (newExpireDate: Date, item: subscription) => {
        let mesi = 12;
        // console.log("## changeValidFromDate", newExpireDate, item, isSubscription)
        if (isSubscription && item) {
            if (item.subscriptionType === "MENSILE") {
                mesi = item.monthToBuy;
            }
        }
        let inizio = moment(newExpireDate).subtract(mesi, 'M').subtract(daysExtra, 'd').toDate();
        setExpireTo(newExpireDate);
        setValidFrom(inizio);
    }

    const accessesExtraIsVisible = () => {
        // console.info("## accessesExtraIsVisible", props.selectedSubscription);
        if (props.selectedSubscription === undefined || props.selectedSubscription?.subscriptionType === undefined)
            return false;
        let s = props.selectedSubscription;
        return isSubscription && s?.subscriptionType === SUBSCRIPTIONTYPES.ACCESSI.code;
    }

    const daysExtraIsVisible = (subscription?: subscription): boolean => {
        // console.info("## daysExtraIsVisible", subscription, props.selectedSubscription);
        if (props.selectedSubscription === undefined || props.selectedSubscription?.subscriptionType === undefined)
            return false;
        let s = props.selectedSubscription;
        return isSubscription && s?.subscriptionType === SUBSCRIPTIONTYPES.MENSILE.code;
    }

    // const isMedical = (): boolean => {
    //     return (props.dialogType === "medical");
    // }

    const templateSearchBoxSubscription = (subscription?: subscription) => {
        let descr = '';
        if (subscription) {
            if (subscription.subscriptionType === SUBSCRIPTIONTYPES.MENSILE.code) {
                descr = ` - ${subscription.monthToBuy > 0 ? subscription.monthToBuy + ' MESI' : 'GIORNI EXTRA'}`;
            }
            // if (subscription.subscriptionType === SUBSCRIPTIONTYPES.ACCESSI.code) {
            //     descr = ` - ${subscription.accessToBuy > 0 ? subscription.accessToBuy : ''} INGRESSI`;
            // }
            if (subscription.subscriptionType === SUBSCRIPTIONTYPES.CORSI.code) {
                descr = ` - CORSO`;
            }
        }
        return subscription ? {
            label: subscription.subscriptionName + descr,
            value: subscription
        } : undefined;
    }

    const setTime = (day, openingDetails) => {
    }

    const loadSubscription = (item: subscription) => {
        // console.info("## loadSubscription", item, props.selectedSubscription);
        if (item) {
            props.loadSubscription(item._id);
        }
        // console.info(props.selectedSubscription);
        // changeSubscriptionValue(props.selectedSubscription);
    }

    const searchSubscriptionSearchBox = (search: string): Promise<Array<subscription>> => {
        return new Promise((resolve, reject) => {
            var i = subscriptionType.value;
            invokeApi({
                // "/api/Subscriptions" + parseQueryStringParameters(textSearch, subscriptionType, subscriptionState),
                path: `/api/Subscriptions?textSearch=${search}&subscriptionType=${i}&subscriptionState=attivi`,
                method: 'GET',
                responseType: "json",
            }).then(val => {
                resolve(val);
            }).catch(val => {
                reject(val)
            })
        })
    }

    const onUpdateMedicalExaminationDocument = (item: medicalExamination) => {
        console.log("## onUpdateMedicalExaminationDocument function in file UpdateSubscriptionDialog medicalExamination:", item)
        setMedicalExaminationDocument(item);
    }

    // render() {
    // const { classes } = props.classes;
    const subscriptionTypes = Object.keys(SUBSCRIPTIONTYPES);
    var isMedical = (props.dialogType === "medical");
    var isSubscription = (props.dialogType === "subscription");
    // var isInsurance = (props.dialogType === "insurance");
    var title = (isMedical ? "Aggiungi Visita Medica" : (isSubscription ? "Aggiungi Abbonamento" : "Aggiungi Iscrizione"));

    const getMedicalExaminationLabel = () => {
        if (isMedical) {
            if ((props.selectedSubscription?.firebaseUri && props.selectedSubscription?.firebaseUri !== null) || medicalExaminationDocument)
                return <b><a href={props.selectedSubscription?.firebaseUri} target='_blank' rel='noopener noreferrer'>VISITA MEDICA</a></b>
            else
                return <p><b>SCANSIONE VISITA MEDICA DA CARICARE</b></p>
        }
        return <></>
    }

    return (
        <Dialog
            open={props.open}
            onClose={Cancel}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
            {<DialogTitle id="alert-dialog-title">{title}</DialogTitle>}
            <DialogContent>
                {/* className={this.props.classes.reservationSlotDetailDialogContent} */}
                <Grid container>
                    <Grid item sm={12}>
                        {isSubscription ? (
                            <Select fullWidth
                                // selected={getSubscriptionType(subscriptionType)}
                                selected={subscriptionType}
                                items={subscriptionTypes.map(t => {
                                    return { name: SUBSCRIPTIONTYPES[t].title, value: t }
                                })}
                                onChange={(item) => changeSubscriptionTypeValue(item)} label='Seleziona un tipo' />
                        ) : <></>}
                    </Grid>
                    <Grid item xs={12} style={{ margin: "5px" }}>
                        {isSubscription ? (
                            <SearchBoxApi<subscription>
                                clearItem={r => ClearItemsRef.current = r}
                                // selectedItem={props.selectedSubscription === undefined ? null : props.selectedSubscription}
                                openOnFocus
                                doFilter
                                disabled={false}
                                listSize={10}
                                getItems={searchSubscriptionSearchBox}
                                label={"Abbonamento"}
                                placeholder={"Cercare abbonamento"}
                                templateItem={templateSearchBoxSubscription}
                                onSelectedChange={(item) => loadSubscription(item)}
                                minCharacterNumber={1} />
                        ) : <></>}
                    </Grid>
                    <Grid item sm={12}>
                        {daysExtraIsVisible() ? <TextField type={"number"} disabled={false}
                            label="Numero Giorni Extra"
                            onChange={(val) => setDaysExtra(Number(val))}
                            value={daysExtra?.toString()}
                        /> : <></>}
                    </Grid>
                    <Grid item sm={12}>
                        {accessesExtraIsVisible() ? (<TextField type={"number"} disabled={false}
                            label="Numero Accessi"
                            onChange={(val) => setAccessesExtra(Number(val))}
                            value={accessesExtra?.toString()}
                        />) : (<></>)}
                    </Grid>
                    <Grid item sm={12}>
                        <TextField
                            label="Note"
                            onChange={(val) => setNotes(val)}
                            value={notes}
                        />
                    </Grid>
                    <Grid item sm={12}>
                        <DatePicker
                            key={`dataInizioValidita-from-date-picker`}
                            label="Data inizio validità"
                            fullWidth
                            //minDate={new Date()}
                            value={validFrom}
                            onChange={(d) => { changeExpireDate(d, props.selectedSubscription); }}
                        />
                    </Grid>
                    <Grid item sm={12}>
                        <DatePicker
                            key={`dataFineValidita-from-date-picker`}
                            label="Data fine validità"
                            fullWidth
                            disabled={false}
                            minDate={new Date()}
                            value={expireTo}
                            onChange={(d) => { changeValidFromDate(d, props.selectedSubscription); }}
                        />
                    </Grid>
                    <Grid item sm={12}>
                        {/* <input style={{ borderBottom: '1px solid grey', borderRight: '1px solid grey', marginRight: '2px' }} type="file" onChange={onFileChange} />
                                                <button style={{ margin: '2px' }} onClick={onFileUpload}>Carica</button>
                                                <button style={{ margin: '2px' }} onClick={fileDelete}>Elimina</button>
                                                {fileData()} */}
                        {props.dialogType === "medical" ? <MedicalExaminationDocument
                            onUpdateMedicalExaminationDocument={onUpdateMedicalExaminationDocument}
                            subscription={props.selectedSubscription}
                            expiresOn={expireTo}
                            validFrom={validFrom}
                            notes={notes}
                            userId={props.userId} /> : <></>}
                        {/* firebaseUri={undefined}
                            documentId={undefined}
                             /> : <></>} */}
                        {/* <span>TEST NOT IS MEDICAL : {props.dialogType} - {JSON.stringify(props.selectedSubscription)}</span>} */}
                    </Grid>
                    {false && isSubscription === true && props.selectedSubscription ?
                        days.map((day, idx) => <DayRow key={'subscription-day-' + idx} classes={props.classes}
                            day={day}
                            disabled={true}
                            value={props.selectedSubscription.subscriptionRules[day.value]}
                            onchange={openingDetails => setTime(day.value, openingDetails)}
                        />) : <></>}
                </Grid>
            </DialogContent >
            <DialogActions>
                {getMedicalExaminationLabel()}
                {/* className={this.props.classes.contactReservationDialogActions} */}
                <SaveButton onClick={Save} />
                <CancelButton onClick={Cancel} />
            </DialogActions>
        </Dialog >
    );
}


const mapStateToProps = (state: IApplicationState, ownProps: any): any => {
    return {
        ...ownProps,
        ...state.subscriptions
    }
}

const mapDispatchToProps = (dispatch: any) => ({
    ...subscriptionsActions(dispatch),
    ...medicalExaminationActions(dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)((WithMediaQuery(AddContactSubscriptionDialog))) as React.ComponentType<IInnerProps>;
